// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b842284c","453":"ab42cb7b","667":"82ae717a","977":"9a72b6a4"}[chunkId] + ".chunk.js";
};